import { useMemo } from 'react';
import { pipe } from 'fp-ts/function';
import { array } from 'fp-ts';
import { WithBillId } from '@mews-commander/types';
import { sumAllAmountsValues } from '@mews-commander/utils';
import { useBillReinstateDetails } from '../hooks';

export const useBillTotalAmount = ({ billId }: WithBillId) => {
    const { orderItems } = useBillReinstateDetails({ billId });

    return useMemo(() => {
        if (!orderItems || array.isEmpty(orderItems)) return;

        return pipe(
            orderItems,
            array.map((orderItem) => orderItem.totalAmount),
            sumAllAmountsValues
        );
    }, [orderItems]);
};
